(function() {

  var defaults = {
    prefix: '',
    format: ''
  };

  var Utils = {

    serialize: function(obj) {
      if (obj === null) {
        return '';
      }
      var s = [];
      for (var prop in obj) {
        if (obj[prop]) {
          if (obj[prop] instanceof Array) {
            for (var i = 0; i < obj[prop].length; i++) {
              var key = prop + encodeURIComponent('[]');
              s.push(key + '=' + encodeURIComponent(obj[prop][i].toString()));
            }
          } else {
            s.push(prop + '=' + encodeURIComponent(obj[prop].toString()));
          }
        }
      }
      if (s.length === 0) {
        return '';
      }
      return '?' + s.join('&');
    },

    clean_path: function(path) {
      return path.replace(/\/+/g, '/').replace(/[\)\(]/g, '').replace(/\.$/m, '').replace(/\/$/m, '');
    },

    extract: function(name, options) {
      var o;
      if (options.hasOwnProperty(name)) {
        o = options[name];
        delete options[name];
      } else if (defaults.hasOwnProperty(name)) {
        o = defaults[name];
      }
      return o;
    },

    extract_format: function(options) {
      var format = options.hasOwnProperty('format') ? options.format : defaults.format;
      delete options.format;
      return format ? '.' + format : '';
    },

    extract_anchor: function(options) {
      var anchor = options.hasOwnProperty('anchor') ? options.anchor : null;
      delete options.anchor;
      return anchor ? '#' + anchor : '';
    },

    extract_options: function(numberOfParameters, args) {
      if (args.length > numberOfParameters) {
        return typeof(args[args.length - 1]) == 'object' ?  args.pop() : {};
      } else {
        return {};
      }
    },

    path_identifier: function(object) {
      if (!object) {
        return '';
      }
      if (typeof(object) == 'object') {
        return ((typeof(object.to_param) == 'function' && object.to_param()) || object.to_param || object.id || object).toString();
      } else {
        return object.toString();
      }
    },

    build_path: function(numberOfParameters, parts, optionalParams, args) {
      args = Array.prototype.slice.call(args);
      var result = Utils.get_prefix();
      var opts = Utils.extract_options(numberOfParameters, args);
      if (args.length > numberOfParameters) {
        throw new Error('Too many parameters provided for path');
      }
      var paramsCount = 0, optionalParamsCount = 0;
      for (var i = 0; i < parts.length; i++) {
        var part = parts[i];
        if (Utils.optional_part(part)) {
          var name = optionalParams[optionalParamsCount];
          optionalParamsCount++;
          // try and find the option in opts
          var optional = Utils.extract(name, opts);
          if (Utils.specified(optional)) {
            result += part;
            result += Utils.path_identifier(optional);
          }
        } else {
          result += part;
          if (paramsCount < numberOfParameters) {
            paramsCount++;
            var value = args.shift();
            if (Utils.specified(value)) {
              result += Utils.path_identifier(value);
            } else {
              throw new Error('Insufficient parameters to build path');
            }
          }
        }
      }
      var format = Utils.extract_format(opts);
      var anchor = Utils.extract_anchor(opts);
      return Utils.clean_path(result + format + anchor) + Utils.serialize(opts);
    },

    specified: function(value) {
      return !(value === undefined || value === null);
    },

    optional_part: function(part) {
      return part.match(/\(/);
    },

    get_prefix: function() {
      var prefix = defaults.prefix;

      if ( prefix !== '' ) {
        prefix = prefix.match('\/$') ? prefix : ( prefix + '/');
      }

      return prefix;
    }

  };

  window.Routes = {
  // v2_albums => /v2/albums(.:format)
  v2_albums_path: function() {
    return Utils.build_path(0, ['/v2/albums'], ['format'], arguments);
  },
  // social_logout => /:provider/logout(.:format)
  social_logout_path: function() {
    return Utils.build_path(1, ['/', '/logout'], ['format'], arguments);
  },
  social_share_param: function() {
    return  '/social/share_social_media?';
  },
  // category_list => /categories(.:format)
  category_list_path: function() {
    return Utils.build_path(1, ['/categories/'], ['format'], arguments);
  },
};
  window.Routes.options = defaults;
})();
